/**
 * A titled part of the case editor, with a line saying what it holds and an action beside its title.
 */

import type { ReactNode } from 'react';

export const Section = ({
	title,
	hint,
	action,
	children
}: {
	title: string;
	hint: string;
	action?: ReactNode;
	children: ReactNode;
}) => (
	<section className='flex flex-col gap-2'>
		<div className='flex items-end justify-between gap-3'>
			<div className='flex min-w-0 flex-col'>
				<h3 className='text-[13px] leading-4.5 font-medium text-text-heading'>{title}</h3>
				<p className='text-xs leading-4 text-gray-800'>{hint}</p>
			</div>
			{action}
		</div>
		{children}
	</section>
);
